import type { FrontendSettings } from '@common/interfaces/frontendSettings';
import { fetchJson } from '@frontend/store/fetch';

export async function getFrontendSettings(): Promise<FrontendSettings> {
    const url = '/api/env';
    const result = await fetchJson({ method: 'GET', url });

    return result.json;
}
